export const LOCATION_OPTIONS = {
  withoutLocation: 'no',
  withLocationIfAvailable: 'optional',
  onlyIfLocationAvailable: 'yes',
  false: 'no',
};
